import { Layout } from "antd";
import React, { useEffect, useRef, useState } from "react";
import logo from "assets/cemlogo.png";
import "./style.scss";
import { Link, useNavigate } from "react-router-dom";
import { IGeneralState, ISidemenu } from "types";
import { useSelector } from "react-redux";

const { Sider } = Layout;

export const Sidemenu: React.FC<ISidemenu> = (props) => {
	const { isCollapsed } = props;
	const { label } = useSelector((state: IGeneralState) => state.app.user);
	const navigate = useNavigate();
	const isManager = label === "manager";
	const sidebarRef = useRef<HTMLDivElement | null>(null)
	const isMobile = () => {
		return window.innerWidth < 766
	}
	const [showSide, setShowSide] = useState(!isMobile())

	useEffect(() => {
		setShowSide(!showSide)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isCollapsed])

	useEffect(() => {
		document.addEventListener('click', handleClickOutside);
		if(isMobile()) {
			//fecha o menu lateral por padrão - MOBILE
			setShowSide(false)
		}

		setShowSide(!isMobile())
	}, []);

	const clickedLink = (e: any) => {
		if(isMobile()) {
			//fecha o menu lateral ao clicar em algum link - MOBILE
			setShowSide(false)
		}
	}

	// Função para fechar a sidebar ao clicar fora dela - MOBILE
	const handleClickOutside = (e: MouseEvent) => {
		if(!isMobile()) {
			return;
		}

		const clickedElement = e.target as HTMLElement;
		if(clickedElement.classList.contains('collapse-btn') || clickedElement.parentElement?.classList.contains('collapse-btn')) {
			return;
		}
		console.log('asd')
		
		if (sidebarRef.current && !sidebarRef.current.contains(clickedElement)) {
			setShowSide(false); // Fecha a sidebar se o clique for fora dela
		}
	};

	const renderMenu = () => {
		return 	<div>
			<div className="sidemenu__logo">
				<img
					src={logo}
					alt="logo"
					onClick={() => navigate("/dash")}
					style={{ cursor: "pointer" }} />
			</div>
			<div className="sidemenu__content">
				{!isManager && (
					<>
						<div className="sidemenu__content__menu">
							<label>Início</label>
							<div className="sidemenu__content__menu__item">
								<Link to="/dash" onClick={clickedLink}>Início</Link>
							</div>
							<div className="sidemenu__content__menu__item">
								<Link to="/my-courses" onClick={clickedLink}>Meus cursos</Link>
							</div>
						</div>
						<hr />
					</>
				)}

				{!isManager && (
					<div className="sidemenu__content__menu">
						<label>Plataforma</label>
						<div className="sidemenu__content__menu__item">
							<Link to="/courses" onClick={clickedLink}>Cursos</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/news" onClick={clickedLink}>Notícias</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/faq" onClick={clickedLink}>Central de ajuda</Link>
						</div>
					</div>
				)}

				{isManager && (
					<div className="sidemenu__content__menu">
						<label>Gerencial</label>
						<div className="sidemenu__content__menu__item">
							<Link to="/dash" onClick={clickedLink}>Início</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-users" onClick={clickedLink}>Usuários</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-courses" onClick={clickedLink}>Cursos</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-news" onClick={clickedLink}>Notícias</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-banners" onClick={clickedLink}>Banners</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-products" onClick={clickedLink}>Produto</Link>
						</div>
						<div className="sidemenu__content__menu__item">
							<Link to="/manage-newsletter" onClick={clickedLink}>Newsletter</Link>
						</div>
					</div>
				)}
			</div>
		</div>
	}

	return (
		<div>

			<div className="d-block d-none d-sm-none d-md-block" style={{height: '100%'}}>
				<Sider
					className="sidemenu z-3"
					style={{height: '100%', display: showSide? 'block' : 'none'}}
				>
					{renderMenu()}
				</Sider>
			</div>

			{/* menu mobile */}
			<div className="d-block position-absolute d-md-none mobile-menu" style={{height: '100%', width: showSide? '100%' : ''}}>
				<Sider
				 	ref={sidebarRef}
					className="sidemenu z-3"
					style={{height: '100%', display: showSide? 'block' : 'none'}}
				>
					{renderMenu()}
				</Sider>
			</div>
		</div>
	);
};
